<template>
  <v-card :loading="loading">
    <v-toolbar dense elevation="1">
      <v-spacer />
      <v-toolbar-title>背景画像の選択</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="cancel" v-on="on"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </template>
        <span>閉じる</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col v-for="item in backgrounds" :key="item.id" cols="4">
          <v-card>
            <v-card-title>{{ item.name }}</v-card-title>
            <v-card-text>
              <v-img
                :src="item.image"
                aspect-ratio="1.4"
                v-ripple
                class="elevation-1"
                @click="select(item)"
              ></v-img>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn icon @click="deleteBackground(item)"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-file-input
        :rules="[v => !v || v.size < 1e6 || '10MB以下です']"
        v-model="file"
        accept="image/*"
        placeholder="ファイル選択（10MB以下）"
        clearable
        dense
        hide-details
        outlined
        small-chips
      >
      </v-file-input>
      <v-spacer />
      <v-btn
        :disabled="file == null"
        :loading="uploading"
        @click="onUpload"
        color="teal"
      >
        <v-icon left>mdi-light mdi-upload</v-icon>
        アップロード
        <template v-slot:loader>
          <v-progress-circular v-model="uploading" indeterminate />
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  addBackground,
  deleteBackGround
} from '@/firebaseAccess/firestoreAccess'

export default {
  name: 'DeviceBackgroundDialog',
  props: {
    deviceId: {
      required: false
    }
  },
  data: () => ({
    file: null,
    base64Image: '',
    loading: false,
    uploading: false,
    finished: false
  }),
  computed: {
    ...mapGetters({
      backgrounds: 'backgrounds/getBackgrounds'
    })
  },
  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack',

      bindBackgroundRef: 'backgrounds/bindRef',
      deleteBackgroundById: 'backgrounds/deleteById'
    }),
    onUpload() {
      this.uploading = true

      const fileName = this.file.name.split('.')[0]
      addBackground(this.deviceId, {
        name: fileName,
        image: this.base64Image
      })
        .then(() => {})
        .finally(() => {
          this.uploading = false
          this.file = null
        })
    },
    deleteBackground(item) {
      deleteBackGround(this.deviceId, item.id).then(() => {
        this.showSnack({ message: '削除されました' })
      })
    },
    getBackgrounds() {
      if (this.deviceId) {
        this.loading = true
        this.bindBackgroundRef(this.deviceId).then(() => {
          this.loading = false
        })
      }
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    select(bg) {
      this.$emit('select', bg.image)
    },
    cancel() {
      this.$emit('cancel')
    }
  },
  watch: {
    deviceId() {
      this.getBackgrounds()
    },
    file() {
      if (this.file) {
        this.getBase64(this.file).then(image => {
          this.base64Image = image
        })
      }
    }
  },
  created() {
    this.getBackgrounds()
  }
}
</script>
